import SvgIcon from "@mui/material/SvgIcon"

export default function LockSendIcon() {
  return (
    <SvgIcon>
      <svg width="18px" height="21px" viewBox="0 0 18 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
          <title>Icon-Lock-Send</title>
          <g id="Manage" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="Manage-Invoices-Lock-Send" transform="translate(-1285, -323)" fill="currentColor" fillRule="nonzero">
                  <g id="Draft-Invoices" transform="translate(312, 221)">
                      <g id="Cygnus" transform="translate(0, 89)">
                          <g id="Icon-Lock-Send" transform="translate(966, 9)">
                              <g transform="translate(7, 4)" id="Shape">
                                  <path d="M5,7 L11,7 L11,5 C11,4.16666667 10.7083333,3.45833333 10.125,2.875 C9.54166667,2.29166667 8.83333333,2 8,2 C7.16666667,2 6.45833333,2.29166667 5.875,2.875 C5.29166667,3.45833333 5,4.16666667 5,5 L5,7 Z M8.25,21 L2,21 C1.45,21 0.979166667,20.8041667 0.5875,20.4125 C0.195833333,20.0208333 0,19.55 0,19 L0,9 C0,8.45 0.195833333,7.97916667 0.5875,7.5875 C0.979166667,7.19583333 1.45,7 2,7 L3,7 L3,5 C3,3.61666667 3.4875,2.4375 4.4625,1.4625 C5.4375,0.4875 6.61666667,0 8,0 C9.38333333,0 10.5625,0.4875 11.5375,1.4625 C12.5125,2.4375 13,3.61666667 13,5 L13,7 L14,7 C14.55,7 15.0208333,7.19583333 15.4125,7.5875 C15.8041667,7.97916667 16,8.45 16,9 L16,10.3 C15.7,10.2 15.3875,10.125 15.0625,10.075 C14.7375,10.025 14.3833333,10 14,10 L14,9 L2,9 L2,19 L7.3,19 C7.43333333,19.4 7.56666667,19.7458333 7.7,20.0375 C7.83333333,20.3291667 8.01666667,20.65 8.25,21 Z M9.5,19.5 L9.5,16.3 L12.7,15.5 L9.5,14.7 L9.5,11.5 L17.5,15.5 L9.5,19.5 Z M2.0375,9 L2.0375,19 L2.0375,9 Z"></path>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
    </SvgIcon>
  )
}
